import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';

export const ConfirmDialogPersonalizado = ({ group, icon = 'pi pi-question', acceptLabel = 'Confirmar', rejectLabel = 'Cancelar', onAccept, onReject }) => {

    return (
        <ConfirmDialog
            group={group}
            content={({ headerRef, contentRef, footerRef, hide, message }) => {
                return (
                    <div className="flex flex-column align-items-center p-5 surface-overlay border-round">
                        <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                            <i className={`${icon} text-5xl`}></i>
                        </div>
                        <span className="font-bold text-2xl block mb-2 mt-4" ref={headerRef}>
                            {message.header}
                        </span>
                        <p className={`mb-0 text-center`} ref={contentRef}>
                            {message.message.texto}
                        </p>
                        <div className="flex align-items-center gap-2 mt-4" ref={footerRef}>
                            <Button label={acceptLabel} className="w-8rem" onClick={(e) => { hide(e); onAccept?.(message); }}
                            />
                            <Button label={rejectLabel} outlined className="w-8rem" onClick={(e) => { hide(e); onReject?.(message); }}
                            />
                        </div>
                    </div>
                );
            }}
        />
    );
};